module.exports = __webpack_public_path__ + "img/EA-sports-logo-icon.2142f6d6.svg";